import React, { useEffect } from 'react';
import FilledInput from '@material-ui/core/FilledInput';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setCookie, clearCookie, getUserDetails } from '../../functions/Auth';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import '../../scss/components/_sign_in_forms.scss';

import API_PATH from "../../constants/config.json";

const queryString = require('query-string');

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


//Start SignIn component code ...
const SignIn = (props) => {
  let history = useHistory();
  const [spacing, setSpacing] = React.useState(2);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [values, setValues] = React.useState({
    email: "",
    pwd: ""
  });
  const [errMsg, setErrMsg] = React.useState(null);
  const [errMsgEmail, setErrMsgEmail] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(null);
  const [errPassword, setErrPassword] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [loader, setLoader] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [getRememberMe, setRememberMe] = React.useState(false);
  const [errorTitle, setErrorTitle] = React.useState(null);

  useEffect(() => {
    if (props.location) {
      const parsed = queryString.parse(props.location.search);
      if (parsed && parsed.emailverification == 'true') {
        setEmail(parsed.email);
        setValues({ ...values, email: parsed.email });
        setErrMsg('Your email has been validated and you\'re ready to explore');
        setErrPopUp(true);
        setErrMsgType('success');
      } else if (parsed && parsed.emailverification == 'false') {
        setErrMsg('Link has been expired.');
        setErrPopUp(true);
        setErrMsgType('error');
      } else if (parsed && parsed.isadmin == 'true') {
        setEmail(parsed.email);
        setValues({ ...values, email: parsed.email });
      } else if (props.location.state) {
        if (props.location.state.invited) {
          setErrMsg('A verification link has been sent to the email that was provided.');
          setErrPopUp(true);
          setErrMsgType('success');
        }
      }
    }
  }, [])

  const handleChange = name => event => {
    if (name == 'email') {
      setEmail(event.target.value);
    }
    setErrEmail(false);
    setErrPassword(false);
    setValues({ ...values, [name]: event.target.value });
  }
  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };


  //This method is use for Sign In form validations start ..
  const validateForm = async e => { 
    setErrMsg(null);
    setErrorTitle(null);
    setErrMsgEmail(null);
    setErrEmail(false);
    setErrPassword(false);
    e.preventDefault()
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;    
    if (values.email == '' &&
      values.pwd == '') {
      setErrEmail(true);
      setErrPassword(true);
      setErrorTitle('Issue signing in')
      setErrMsg('All fields are required');
      setErrPopUp(true)
    } else if (values.email == '') {
      setErrEmail(true)
      setErrMsg('Email required');
      setErrPopUp(true)
    } else if (!checkEmail.test(values.email)) {
      setErrEmail(true)
      setErrMsgEmail('Please enter a valid email address');
      setErrPopUp(true)
    } else if (values.pwd == '') {
      setErrPassword(true);
      setErrMsg('Password required.');
      setErrPopUp(true)
    } else {
      signInUser();
    }
  }
  //This method is use for Sign In form validations end ..


 //This method is use for API call to sign in user start ..
  const signInUser = () => { 
    setLoader(true);
    clearCookie('alLogIn');
    try {
      axios({
        method: 'post',
        data: { ...values, ...{ rememberMe: getRememberMe } },
        url: API_URL + API_PATH.signInAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            if (response.data.session) {
              await setCookie('session', response.data.session);
              await setCookie('email', values.email);
              history.push({
                pathname: '/set_new_password',
                state: { newLogin: true }
              });
            }
            else {
              await setCookie('email', response.data.email);
              await setCookie('idToken', response.data.IdToken);
              await setCookie('payload', response.data.payload);
              await setCookie('atexpiry', response.data.access_token_expiry);
              await setCookie('alLogIn', getRememberMe);
              await refreshToken();
            }
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error')
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true)
            setLoader(false);
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }
  //This method is use for API call to sign in user end ..


  //This method is use for call refresh token start ..
  const refreshToken = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getcsrftoken,
      })
        .then(async function (response) {
          if (response && response.data && response.data.csrfToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
            await getProfile(response.data.csrfToken);
          } else {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          setLoader(false);
        })
        .catch(function (error) {
          if (Cookies.get('email')) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
          }
          setErrMsgType('error')
          setErrMsg('Something went wrong.');
          setErrPopUp(true)
          setLoader(false);
        })
    } catch (error) {
      if (Cookies.get('email')) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
      }
      setErrMsgType('error')
      setErrMsg('Something went wrong.');
      setErrPopUp(true)
      setLoader(false);
    }
  }
  //This method is use for call refresh token end ..


  //This method is use for get user information start ...
  const getProfile = async (csrfToken) => {
    let details = await getUserDetails();
    try {
      axios({
        method: 'get',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        url: API_URL + API_PATH.getMyProfileAPI + `${details.user_id}`,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            await setCookie('firstName', response.data.data.first_name);
            await setCookie('organization', response.data.data.organization);
            await setCookie('lastName', response.data.data.last_name);
            history.push({
              pathname: '/UsersDashboard',
              state: { newLogin: true }
            });

          } else {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('organization');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          setLoader(false);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.message) {
              setErrMsgType('error')
              setErrMsg(error.response.data.message.message);
              setErrPopUp(true)
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
            }
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          if (Cookies.get('email')) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('organization');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
          }
          setLoader(false);
        })
    } catch (error) {
      console.error(error);
    }
  }
 //This method is use for get user information end ...


  const handleRemember = () => {
    setRememberMe(prev => !prev);
  }

  return (
    <React.Fragment>
      {/* <Header /> */}
      <CssBaseline />
      <div className="signin-main">
        <Container className="user-form-container shadow-xl" maxWidth="sm">
          <Typography component="div">
            <div className="form-logo">
              <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} /></NavLink>
              <img src={require('../../assets/images/dataPointLogo.svg')} className="form-icon"></img>
            </div>
            <form className="root-form" noValidate autoComplete="off" onSubmit={e => validateForm(e)} >
              <h3 className="h3-title">Sign in to your account</h3>
              <p className="center-text margin-0"><label className="default-label">Or</label> <NavLink to="/sign_up" className="link-label">Create an account</NavLink></p>
              <Grid container className="root-box shadow-default" >
                <Grid item xs={12}>
                {errMsg ?
                  <ErrorMessage title={errorTitle} message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} />
                : null}
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className="paper" >
                        <p className="text-input-label">Email address</p>
                        <FilledInput 
                          id="email" 
                          placeholder="you@example.com" 
                          className={errEmail ? "form-text-input-error" : "form-text-input"} 
                          type="email" variant="outlined" required 
                          onChange={handleChange('email')} 
                          data-testid='email' 
                          value={email} 
                          endAdornment={ errEmail && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                        />
                        {errEmail ? <p className="form-error-label">{errMsgEmail}</p> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" >
                        <p className="text-input-label">Password</p>
                        <FilledInput 
                          id="password" 
                          className={errPassword ? "form-text-input-error" : "form-text-input"} 
                          type="password" 
                          variant="outlined" required 
                          onChange={handleChange('pwd')} 
                          data-testid='password'
                          endAdornment={ errPassword && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                        />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" >
                        <FormControlLabel
                          value="Remember me"
                          control={<Checkbox color="primary" value={getRememberMe} onChange={handleRemember} />}
                          label="Remember me"
                          labelPlacement="end"
                          id="reminder_check_bx"
                          className="sign-form-checkbox"
                        />
                        <NavLink to="/forgot_password" className="link-label" style={{float: 'right', paddingTop: '10px'}} data-testid='forgotPwdLink'>Forgot your password?</NavLink>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="submit" variant="outlined" id="signIn_btn" className="blue-btn" data-testid='signIn_btn'>
                          {loader == true ?
                            <CircularProgress />
                            :
                            'Sign in'
                          }
                        </Button>
                        <div className="signin-divisor"><label>Or</label></div>
                        <p style={{paddingTop: '26px'}} className="margin-0"><NavLink to="/sign_up" data-testid='signUpLink' className="link-label font-16">Create an account</NavLink></p>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default SignIn
//End SignIn component code ...